import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import { UserContext } from './UserContext';
import { GatesNowDataProvider } from './GatesNowDataContext';
import AppTopBar from './AppTopbar';
import { GateNowMap } from './pages/GateNowMap';
import { ConcessionsGateNow } from './pages/ConcessionsGateNow';
import { ActiveViewersPanel } from './components/ActiveViewersPanel';
import { usePresenceHeartbeat } from './hooks/usePresenceHeartbeat';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './fonts.css';
import './App.scss';

const TABS = [
  { label: 'Map', icon: 'pi pi-fw pi-map', path: '/map' },
  { label: 'Table', icon: 'pi pi-fw pi-table', path: '/table' },
];

const pathToIndex = (pathname) => (pathname.startsWith('/table') ? 1 : 0);

const App = () => {
  const user = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const activeIndex = pathToIndex(location.pathname);
  usePresenceHeartbeat();

  // Any signed-in Entra user may use Map/Table. Active Viewers stays gated to
  // ACAA WebApp Access inside ActiveViewersPanel (general / webaccess).
  const signedIn = Boolean(user?.userInfo);

  useEffect(() => {
    if (location.pathname === '/') {
      navigate('/map', { replace: true });
    }
  }, [location.pathname, navigate]);

  const selectTab = (path) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  const containerClassName = classNames('layout-wrapper', 'menu-layout-static', 'layout-menu-static-inactive', {
    'has-topbar-tabs': signedIn,
  });

  return (
    <div className={containerClassName}>
      <AppTopBar
        activeUser={user}
        profileMode="top"
        tabs={signedIn ? TABS : null}
        activeIndex={activeIndex}
        onTabSelect={selectTab}
      />
      {signedIn ? (
        <>
          {/* Mobile-only strip: desktop tabs live in the topbar. */}
          <div className="menu menu--mobile-tabs">
            <div className="col">
              <nav className="gatesnow-tabs" aria-label="Gates Now views">
                {TABS.map((tab, index) => (
                  <button
                    key={tab.path}
                    type="button"
                    className={classNames('gatesnow-tab', { 'is-active': activeIndex === index })}
                    aria-current={activeIndex === index ? 'page' : undefined}
                    onClick={() => selectTab(tab.path)}
                  >
                    <i className={tab.icon} aria-hidden />
                    <span>{tab.label}</span>
                  </button>
                ))}
              </nav>
            </div>
          </div>

          <GatesNowDataProvider>
            <div className={classNames('layout-main', activeIndex === 1 ? 'is-table' : 'is-map')}>
              <Routes>
                <Route path="/" element={<GateNowMap />} />
                <Route path="/map" element={<GateNowMap />} />
                <Route path="/table" element={<ConcessionsGateNow />} />
              </Routes>
              {activeIndex !== 1 && <ActiveViewersPanel />}
            </div>
          </GatesNowDataProvider>
        </>
      ) : (
        <div className="layout-main" style={{ textAlign: "center", padding: "20px" }}>
          <h1 style={{ fontSize: "20px", fontWeight: "bold", color: "#333", marginTop: "100px" }}>
            Unable to load profile
          </h1>
          <p style={{ fontSize: "20px", color: "#555" }}>
            Sign in with your flypittsburgh account, then refresh if this persists.
          </p>
        </div>
      )}
    </div>
  );
};

export default App;
